"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.initialState = void 0;
var immutability_helper_1 = __importDefault(require("immutability-helper"));
var union_1 = __importDefault(require("lodash/union"));
var object_1 = require("remota-client/util/object");
var action_1 = require("./action");
var initialState = function (module) { return ({
    module: module,
    isInitializedMap: {},
    idsMap: {},
    headerMap: {},
    itemMap: {},
    newItems: [],
    cursorMap: {},
    countMap: {},
}); };
exports.initialState = initialState;
function reducer(state, payload) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (payload.module !== state.module) {
        return state;
    }
    switch (payload.subtype) {
        case action_1.RESET: {
            return (0, immutability_helper_1.default)(state, {
                isInitializedMap: { $set: {} },
                idsMap: { $set: {} },
                headerMap: { $set: {} },
                itemMap: { $set: {} },
                newItems: { $set: [] },
                cursorMap: { $set: {} },
                resetAt: { $set: Date.now() },
            });
        }
        case action_1.SET_RESULT: {
            var queryHash = payload.queryHash, _j = payload.result, items_1 = _j.items, cursor = _j.cursor, count = _j.count;
            var newItemIds = (0, union_1.default)(state.idsMap[queryHash] || [], items_1.map(function (item) { return item.id; }));
            return (0, immutability_helper_1.default)(state, {
                isInitializedMap: (_a = {}, _a[queryHash] = { $set: true }, _a),
                idsMap: (_b = {}, _b[queryHash] = { $set: newItemIds }, _b),
                headerMap: { $apply: function (headerMap) { return (0, object_1.mergeItem)(headerMap, items_1); } },
                cursorMap: (_c = {}, _c[queryHash] = { $set: cursor }, _c),
                countMap: (_d = {}, _d[queryHash] = { $set: count }, _d),
            });
        }
        case action_1.SET_ITEMS:
            return (0, immutability_helper_1.default)(state, {
                headerMap: { $apply: function (headerMap) { return (0, object_1.mergeItem)(headerMap, payload.items); } },
                itemMap: { $apply: function (itemMap) { return (0, object_1.mergeItem)(itemMap, payload.items); } },
            });
        case action_1.SET_HEADER_ITEMS:
            return (0, immutability_helper_1.default)(state, {
                headerMap: { $apply: function (headerMap) { return (0, object_1.mergeItem)(headerMap, payload.items); } },
            });
        case action_1.ADD_ITEM:
            return (0, immutability_helper_1.default)(state, {
                headerMap: (_e = {}, _e[payload.item.id] = { $set: payload.item }, _e),
                itemMap: (_f = {}, _f[payload.item.id] = { $set: payload.item }, _f),
                newItems: { $push: [payload.item] },
            });
        case action_1.PREPEND_ITEM:
            return (0, immutability_helper_1.default)(state, {
                headerMap: (_g = {}, _g[payload.item.id] = { $set: payload.item }, _g),
                idsMap: (_h = {}, _h[payload.queryHash] = { $unshift: [payload.item.id] }, _h),
            });
        case action_1.DELETE_ITEMS:
            return (0, immutability_helper_1.default)(state, {
                headerMap: { $unset: payload.ids },
                itemMap: { $unset: payload.ids },
                idsMap: { $apply: function (idsMap) { return (0, object_1.deleteIds)(idsMap, payload.ids); } },
            });
        default: {
            var _1 = payload;
            return state;
        }
    }
}
exports.reducer = reducer;
